export default function sortStrings(first, second) {
    return first.localeCompare(second);
}
//# sourceMappingURL=sort-strings.js.map